/**
 * очищает ключ переменной от тега span
 * @param html string
 * @returns string
 */
export const cleanVarMentions = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const elementsWithMentions = doc.querySelectorAll(
    'span[data-type="mention"]'
  );
  // заменяем <span data-type="mention">переменная</span> на переменная
  elementsWithMentions.forEach((element) => {
    element.replaceWith(element.innerHTML.replace(/&nbsp;/g, ' '));
  });

  const cleanHtml = doc.body.innerHTML;
  return cleanHtml;
};
